/**
 * SabrTrader theme behaviors.
 * Progressive enhancement only — every section renders fully without JS.
 *  - scroll reveal (.tx-reveal)
 *  - metric count-up ([data-tx-count])
 *  - ticker speed normalization (.tx-feed__track)
 *  - live terminal readout flicker (.tx-terminal[data-tx-live])
 */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    setupReveal();
    setupCounters();
    setupTickers();
    setupTerminalReadout();
  }

  /* ---- scroll reveal ---- */
  function setupReveal() {
    var nodes = document.querySelectorAll('.tx-reveal');
    if (!nodes.length) return;

    if (reducedMotion || !('IntersectionObserver' in window)) {
      nodes.forEach(function (n) {
        n.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );

    nodes.forEach(function (n) {
      observer.observe(n);
    });
  }

  /* ---- metric count-up ---- */
  function setupCounters() {
    var nodes = document.querySelectorAll('[data-tx-count]');
    if (!nodes.length) return;

    if (reducedMotion || !('IntersectionObserver' in window)) return; // final value is already in the markup

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          animateCount(entry.target);
        });
      },
      { threshold: 0.4 }
    );

    nodes.forEach(function (n) {
      observer.observe(n);
    });
  }

  function animateCount(el) {
    var raw = el.getAttribute('data-tx-count') || '';
    var target = parseFloat(raw.replace(/[^0-9.\-]/g, ''));
    if (isNaN(target)) return;

    var finalText = el.textContent;
    var decimals = (raw.split('.')[1] || '').length;
    var duration = 1200;
    var start = null;

    function frame(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = (target * eased).toFixed(decimals);
      if (p < 1) {
        window.requestAnimationFrame(frame);
      } else {
        el.textContent = finalText; // restore exact authored value incl. separators
      }
    }

    window.requestAnimationFrame(frame);
  }

  /* ---- ticker: constant px/s speed regardless of item count ---- */
  function setupTickers() {
    document.querySelectorAll('.tx-feed__track').forEach(function (track) {
      var pxPerSecond = parseFloat(track.getAttribute('data-tx-speed')) || 60;
      var distance = track.scrollWidth / 2; // track holds two copies of the list
      if (distance > 0) {
        track.style.setProperty('--tx-feed-speed', (distance / pxPerSecond).toFixed(2) + 's');
      }
    });
  }

  /* ---- simulated live readout in the hero terminal ---- */
  function setupTerminalReadout() {
    if (reducedMotion) return;

    document.querySelectorAll('[data-tx-live]').forEach(function (terminal) {
      var priceEl = terminal.querySelector('[data-tx-price]');
      var deltaEl = terminal.querySelector('[data-tx-delta]');
      if (!priceEl) return;

      var base = parseFloat(priceEl.getAttribute('data-tx-price'));
      if (isNaN(base)) return;

      var decimals = (priceEl.getAttribute('data-tx-price').split('.')[1] || '').length;
      var price = base;

      window.setInterval(function () {
        if (document.hidden) return;
        var step = base * 0.00018;
        price += (Math.random() - 0.5) * step * 2;
        // keep the walk tethered to the base value
        price += (base - price) * 0.05;

        priceEl.textContent = price.toLocaleString('en-US', {
          minimumFractionDigits: decimals,
          maximumFractionDigits: decimals,
        });

        if (deltaEl) {
          var changePct = ((price - base) / base) * 100;
          var sign = changePct >= 0 ? '+' : '';
          deltaEl.textContent = sign + changePct.toFixed(2) + '%';
          deltaEl.classList.toggle('tx-delta--up', changePct >= 0);
          deltaEl.classList.toggle('tx-delta--down', changePct < 0);
        }
      }, 1400);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // re-run hooks when the theme editor re-renders a section
  document.addEventListener('shopify:section:load', init);
})();
